const convertStringToHHMMSS = (value: string): string => {
  return value.replace(/[^0-9,:]/g, '').substring(0, 8)
}

export default convertStringToHHMMSS
